export const FIXED_IMG_URL_MAP = {
    PAGE_PADDING_ICON: 'udata/pkg/fe/ks-fe-zt-pay-services/invoice/img_nohistory_line.png',
    PAGE_SUCCESS_ICON: 'udata/pkg/fe/pic_success_xxl_color.17721830.png',
    PAGE_FAILED_ICON: 'udata/pkg/fe/state-failed.57926129.png',
    PAGE_PROCESSING_ICON: 'udata/pkg/fe/ks-fe-zt-pay-services/invoice/img_nohistory_line.png',
    UPLOADED_PAGE_ICON: 'udata/pkg/KS-COLLECT/uploaded-page-icon.png',
    EXPIRED_PAGE_ICON: 'udata/pkg/KS-COLLECT/expired-page-icon.png',
    NETWORK_ERROR_ICON: 'udata/pkg/fe/error.ba2da25a.png',
};
export function withDynamicCdn(url) {
    const cdnPublic = window.cdn_public || 'h2.static.yximgs.com';
    return `https://${cdnPublic.replace('//', '')}/${url}`;
}

export function getFixedImgUrl() {
    const formatMap = Object.keys(FIXED_IMG_URL_MAP).reduce((acc, key) => {
        acc[key] = withDynamicCdn(FIXED_IMG_URL_MAP[key]);
        return acc;
    }, {});
    return formatMap;
}